import { render, staticRenderFns } from "./DeliveryAddressNewForm.vue?vue&type=template&id=c97edc4e&"
import script from "./DeliveryAddressNewForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddressNewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports